// Tags that already create their own line break. A newline touching one is
// source formatting from the CMS textarea, not an author-intended break.
const BLOCK_TAGS =
  'address|article|aside|blockquote|br|dd|div|dl|dt|fieldset|figcaption|' +
  'figure|footer|form|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|' +
  'tbody|td|tfoot|th|thead|tr|ul';
const AFTER_BLOCK_TAG = new RegExp(
  `(</?(?:${BLOCK_TAGS})\\b[^>]*>)[^\\S\\n]*\\n\\s*`,
  'gi'
);
const BEFORE_BLOCK_TAG = new RegExp(
  `\\s*\\n[^\\S\\n]*(?=</?(?:${BLOCK_TAGS})\\b)`,
  'gi'
);

// CMS text arrives with raw newlines; blocks render them as <br> via
// unsafeHTML. Editors may also type basic markup, so newlines that only
// indent that markup are dropped rather than turned into stray breaks.
export const withLineBreaks = string =>
  !string
    ? ''
    : string
        .replace(/\r\n/g, '\n')
        .replace(AFTER_BLOCK_TAG, '$1')
        .replace(BEFORE_BLOCK_TAG, '')
        .split('\n')
        .join('<br>');
